import { requestForToken, onMessageListener } from "../config/firebase";

export const requestToken = () => {
  return requestForToken().then((s) => {
    console.log("Token has been successfully registered : ", s);
    //   dispatch(setNotificationToken(s));
    localStorage.setItem("notification_token", s);
  });
};
